import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Button } from '@treams/treams-ui/common/button/Button';

import EditModal from './EditModal';

export default function CreateModal(props: {
	item: graphql.EvaluationSectionItem;
	onCancel: () => void;
	onCreate: (item: graphql.EvaluationSectionItem) => void;
}): ReactElement {
	const { t } = useTranslation();

	const [item, setItem] = useState<graphql.EvaluationSectionItem | undefined>(undefined);

	return (
		<>
			<EditModal item={item || props.item} onUpdate={(_, item) => setItem(item)} />
			<Flex justifyContent="flex-end">
				<Button
					mr={2}
					onClick={() => props.onCancel()}
					title={t('common.cancel')}
					type="secondary"
				/>
				<Button
					disabled={!item}
					onClick={() => item && props.onCreate(item)}
					title={t('common.add')}
				/>
			</Flex>
		</>
	);
}
